import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { navigate } from 'gatsby'
import GatsbyImage from 'gatsby-image'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import OmittedText from 'src/components/atoms/OmittedText'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { vwSize } from 'src/utils/vwCss'

const SeminarCard = ({
  title,
  description,
  thumbnail,
  tags,
  date,
  to,
  ...props
}) => {
  const handleClick = () => navigate(to)

  return (
    <Card {...props} onClick={handleClick}>
      <FadeDownWrap>
        <CardInner>
          {thumbnail && <Thumbnail fluid={thumbnail.childImageSharp.fluid} />}
          <Summary>
            <Meta>
              <Date>{date}</Date>
              {Array.isArray(tags) && (
                <Tags>
                  {tags &&
                    tags.map(tag => {
                      if (!tag) {
                        return
                      }
                      return <Tag>{tag}</Tag>
                    })}
                </Tags>
              )}
            </Meta>

            <Title as="h3">{title}</Title>
            <Description>{description}</Description>
            <SpText>詳しく見る</SpText>
          </Summary>
        </CardInner>
      </FadeDownWrap>
    </Card>
  )
}

const Card = styled.div`
  border-radius: ${Styles.pc.borderRadius};
  overflow: hidden;
  margin-bottom: ${vwSize(32, 'pc')}vw;
  filter: drop-shadow(8px 8px 20px rgba(112, 181, 197, 0.15));
  background: ${Styles.color.grayscale[100]};

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    border-radius: ${Styles.sp.borderRadius};
    margin-bottom: ${vwSize(32, 'sp')}vw;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`
const CardInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: ${vwSize(32, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    flex-direction: column;
    padding: 0;
  }
`

const Thumbnail = styled(GatsbyImage)`
  box-sizing: border-box;
  display: block;
  width: ${vwSize(320, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: 100%;
  }
`
const Summary = styled.div`
  width: ${vwSize(664, 'pc')}vw;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: 100%;
  }
`
const Meta = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: ${vwSize(24, 'sp')}vw ${vwSize(16, 'sp')}vw 0;
  }
`
const Date = styled(Typography)`
  color: ${Styles.color.secondary[300]};
  line-height: ${Styles.lineHeight[350]};
  font-size: ${Styles.pc.fontSize.text};
  font-weight: ${Styles.fontWeight.bold};
  display: block;
  margin-right: ${vwSize(16, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.text};
    margin-right: ${vwSize(16, 'sp')}vw;
  }
`
const Tags = styled.div`
  display: flex;
  align-items: center;
`
const Tag = styled.div`
  margin-right: ${vwSize(6, 'pc')}vw;
  background: ${Styles.color.primary[200]};
  color: ${Styles.pc.color.text};
  font-size: ${Styles.pc.fontSize.tag};
  border-radius: ${Styles.pc.borderRadius};
  line-height: ${Styles.lineHeight[350]};
  box-sizing: border-box;
  padding: ${vwSize(4, 'pc')}vw ${vwSize(16, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-right: ${vwSize(8, 'sp')}vw;
    padding: ${vwSize(4, 'sp')}vw ${vwSize(8, 'sp')}vw;
    font-size: ${Styles.sp.fontSize.tag};
    border-radius: ${Styles.sp.borderRadius};
  }
`
const Title = styled(Typography)`
  font-weight: ${Styles.fontWeight.bold};
  font-size: ${vwSize(24, 'pc')}vw;
  line-height: ${Styles.lineHeight[350]};
  color: ${Styles.color.primary[400]};
  margin-top: ${vwSize(16, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(16, 'sp')}vw;
    font-size: ${Styles.sp.fontSize.text};
    padding: 0 ${vwSize(16, 'sp')}vw;
  }
`
const Description = styled.div`
  font-size: ${Styles.pc.fontSize.text};
  font-weight; ${Styles.fontWeight.normal};
  line-height:${Styles.lineHeight[350]};
  color: ${Styles.pc.color.text};
  margin-top: ${vwSize(16, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.text};
    margin-top: ${vwSize(16, 'sp')}vw;
    padding: 0 ${vwSize(16, 'sp')}vw ${vwSize(24, 'sp')}vw;
  }
`
const SpText = styled(Typography)`
  display: none;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    display: block;
    text-align: center;
    color: ${Styles.color.grayscale[100]};
    font-size: ${Styles.sp.fontSize.text};
    font-weight: ${Styles.fontWeight.bold};
    line-height: ${Styles.lineHeight[350]};
    padding: ${vwSize(12, 'sp')}vw 0;
    background: ${Styles.color.secondary[300]};
  }
`

export default SeminarCard
